/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { SmoothScrollLink } from 'organism-react-scroll-nav';
import { inject, observer } from 'mobx-react';
import { NAV_HEIGHT } from 'common/consts/navigation';
import styled from 'styled-components';
import ds, { media } from 'designsystem';
import DesktopMenuItem from './DesktopNavigation/DesktopMenuItem';
import LanguageLink from '../../elements/LanguageLink';

const MenuLink = styled(LanguageLink)`
  cursor: pointer;
  display: flex;
  font-size: ${ds.fontSize('base')};
  font-family: ${ds.get('type.fontFamily.text')};
  color: ${({ highlighted }) => highlighted ? ds.brand('product') : ds.brand('text')};
  font-weight: ${({ active }) => (active ? ds.get('type.fontWeight.bold') : ds.get('type.fontWeight.regular'))};
  text-decoration: none;
  padding: ${ds.get('metrics.xs')} 0 ${ds.get('metrics.xs')} 0;

  ${media.desktop`
    padding: 0 ${ds.get('metrics.s')};
  
    &:after {
      content: '';
      display: block;
      top: calc(${ds.get('metrics.m')} + ${ds.get('metrics.s')} / 2);
      width: ${({ active }) => (active ? ds.get('metrics.base') : 0)};
      height: 4px;
      position: absolute;
      background-color: ${ds.brand('secondary')};
      transition-duration: 0.25s;
    }
  `}
`;

@inject('windowStore', 'navigationStore')
@observer
class MenuButtons extends Component {
  render() {
    const {
      parsedStructure,
      buttonComponent,
      windowStore,
      navigationStore,
    } = this.props;

    return (parsedStructure.map((section, sectionIndex) => (section.urlSlug ? (
      <MenuLink
            to={section.urlSlug}
            highlighted={section.highlighted || false}
            key={`navScroll-${sectionIndex + 1}`}
            onClick={() => navigationStore.closeMobileNav()}
      >
        {section.sectionName}
      </MenuLink>
    ) : (
      <SmoothScrollLink
        key={`navScroll-${sectionIndex + 1}`}
        scrollRefId="nav-parent"
        container={buttonComponent || <DesktopMenuItem />}
        targetId={`scroll-${sectionIndex + 1}`}
        scrollMargin={(windowStore.isOnTablet ? 0 : NAV_HEIGHT)}
      >
        {section.sectionName}
      </SmoothScrollLink>
    ))));
  }
}

export default MenuButtons;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/MenuButtons.jsx